import * as React from 'react';
import styles from './SpineBackground.scss';
import { AnimationState, AnimationStateData, SpinePlayer } from '@esotericsoftware/spine-player';
import classNames from 'classnames';
import equal from 'fast-deep-equal/react';
import { logInfo } from '~/utils/logging';

interface ISpineBackground {
    name: string;
    spine: ISpine;
    viewportWidth: number;
    viewportHeight: number;
    animationNameByDefault?: string;
    containerId: string;
    setPlayer: (player: SpinePlayer) => void;
}

const SpineBackground = ({ setPlayer, spine, name, viewportWidth, viewportHeight, animationNameByDefault, containerId }: ISpineBackground) => {
    const [isVisible, setVisible] = React.useState(false);

    React.useEffect(() => {
        if (!spine) {
            return;
        }

        new SpinePlayer(containerId, {
            jsonUrl: spine.jsonUrl,
            atlasUrl: spine.atlasUrl,
            preserveDrawingBuffer: false,
            animation: animationNameByDefault || 'idle',
            // debug: {
            //     regions: true,
            //     bones: true,
            //     bounds: true,
            // },
            viewport: {
                x: 0,
                y: 0,
                debugRender: false,
                padBottom: 0,
                padLeft: 0,
                padRight: 0,
                padTop: 0,
                width: viewportWidth,
                height: viewportHeight,
            },
            premultipliedAlpha: true,
            backgroundColor: '#00000000',
            alpha: true,
            showLoading: false,
            showControls: false,
            success: (player: SpinePlayer) => {
                const animationStateData = new AnimationStateData(player.skeleton.data);
                animationStateData.defaultMix = 0;

                player.animationState = new AnimationState(animationStateData);

                setVisible(true);
                setPlayer(player);
            },
            error: (spinePlayer, error) => {
                logInfo(`[spine] Player with name ${name} was finished with error.`, new Error(error));
            },
        });
    }, []);

    const classesWrapper = classNames(styles.wrapper, {
        [styles.visible]: isVisible,
    });

    return <div className={classesWrapper} id={containerId}></div>;
};

export default React.memo(SpineBackground, equal);
